import React, { FC, createRef, useEffect } from 'react';

interface IProps {
  file?: File;
  finish: () => void;
}

const FileDownload: FC<IProps> = ({ file, finish }) => {
  const aRef = createRef<HTMLAnchorElement>();

  const downloadFile = async (a: HTMLAnchorElement) => {
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);
      reader.addEventListener('load', () => {
        const { result } = reader;

        if (result) {
          a.download = file.name;
          a.href = result.toString();
          a.click();
          a.download = '';
          a.href = '';
          finish();
        }
      });
    }
  };

  useEffect(() => {
    if (aRef.current) downloadFile(aRef.current);
  }, [file]);

  return (
    <a
      ref={aRef}
      data-testid="cmp-file-download"
      style={{ display: 'none' }}
      href=""
      download=""
    >
      Download
    </a>
  );
};

export default FileDownload;
